import moment from "moment";
import { Block, ContentType, State, TaxonomyEntry } from "../types";
import { TaxonomyEntryType } from "../types";
import { extractKeysAndIndexes } from "../state/getDefaultState";

const HighlightMinLength = 3;
const DateFormats = [
    "MMM D YYYY",
    "MMM D, YYYY",
    "MMMM D YYYY",
    "MMMM D, YYYY",
    "MM-DD-YYYY",
    "DD-MM-YYYY",
    "MM/DD/YYYY",
    "DD/MM/YYYY",
];

const GetDate = (value: string, block: Block) : string => {
  let matchingDateFormat = ""
  const textContent = block.element.textContent;

  DateFormats.forEach(element => {
    var dateFormat = (moment(value).format(element));
    if (textContent?.includes(dateFormat)) {
      matchingDateFormat = dateFormat;
    }
  });

  return matchingDateFormat;
}

export const GetHighlightedText = (block: Block, taxonomy: TaxonomyEntry[], values: State["values"] ) : Array<string> => {
  const highlights: Array<string> = []; 
  if (block.references.length > 0 && (block.type === ContentType.TableCell || block.type === ContentType.Text)) {
    block.highlights.length = 0;
    for(let i = 0; i <  block.references.length; i++){
      let reference = block.references[i];
      if (reference in values) {
        const value = values[reference];
        const entry = extractKeysAndIndexes(value.valueKey, taxonomy).taxonomyEntry;
        switch (entry.type) {
          case TaxonomyEntryType.Date:
            var result = GetDate(value.value, block).toString();
            if (result.length > HighlightMinLength) {
              highlights.push(result);
            }
            break;
          case TaxonomyEntryType.DateTime:
            break;   
          case TaxonomyEntryType.Selection:
          case TaxonomyEntryType.String:
          case TaxonomyEntryType.Number:
            if (values[reference].valueRaw.length >= HighlightMinLength){
              highlights.push(value.valueRaw)
            }
            break;
        }
      }
    }
  }
  return highlights;
}